export default function Sidebar({ activeMenu, setActiveMenu }) {
  const menu = ["Dashboard", "Accounts", "Fee Structure"];

  return (
    <aside className="w-64 bg-blue-900 text-white min-h-screen">
      <nav className="p-3 space-y-1">
        {menu.map((item) => (
          <div
            key={item}
            onClick={() => setActiveMenu(item)}
            className={`px-4 py-2 rounded cursor-pointer
              ${activeMenu === item ? "bg-blue-700" : "hover:bg-blue-800"}`}
          >
            {item}
          </div>
        ))}
      </nav>
    </aside>
  );
}
